<template>
    <div class="el-table-container">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" @submit.native.prevent>
            <el-form-item prop="keyword" label="关键字查询：">
                <el-input v-model.trim="searchForm.keyword" maxlength="50" placeholder="请输入功能标识ID、功能名称（限20字）" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('identificationList:add')" type="primary" size="small" icon="el-icon-plus" @click="addEdit(null, 'add')">新增</el-button>
                <el-button v-if="hasPermission('identificationList:del')" type="danger" size="small" icon="el-icon-delete" @click="del()">批量删除</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small" height="100%"
                class="table" border ref="multipleTable" row-key='id' @selection-change="selectionChangeHandle">
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column prop="fonctionsNumber" label="功能标识ID" show-overflow-tooltip></el-table-column>
            <el-table-column prop="fonctionsName" label="功能名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="detailType" label="功能类型" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{$dictUtils.getDictLabel("detailType", scope.row.detailType ,'')}}
                </template>
            </el-table-column>
            <el-table-column prop="disabled" label="状态">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.disabled" active-value="0" inactive-value="1"></el-switch>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button v-if="hasPermission('identificationList:edit')" type="text" size="small"
                               @click="addEdit(scope.row, 'edit')">修改
                    </el-button>
                    <el-button v-if="hasPermission('identificationList:del')" type="text" size="small"
                               @click="del(scope.row.id)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <IdentificationForm ref="identificationForm" @refreshDataList="refreshList"></IdentificationForm>
        <ImportData ref="importData"></ImportData>
        <ExportData ref="exportData"></ExportData>
        <AdvancedSearch ref="advancedSearch"></AdvancedSearch>
    </div>
</template>

<script>
    import IdentificationForm from './identificationForm'
    import ImportData from '@/components/importData/importData'  // 导入弹窗
    import ExportData from '@/components/exportData/exportData'  // 导出弹窗
    import AdvancedSearch from '@/components/advancedSearch/advancedSearch' // 高级筛选弹窗

    export default {
        components: {IdentificationForm, ImportData, ExportData, AdvancedSearch},
        data() {
            return {
                searchForm: {
                    keyword: '',
                    current: 1,
                    size: 20,
                },
                dataList: [],
                total: 0,
                dataListSelections: [],
                loading: false,
            }
        },
        mounted() {
            this.refreshList()
        },
        methods: {
            refreshList(type) {
                if(type == 1) {
                    this.searchForm.current = 1
                }
                this.loading = true
                this.$axios(this.api.metadata.metadatafonctionsList, this.searchForm, 'get').then(data => {
                    if (data && data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                    } else {
                        this.$message.error('查询失败');
                    }
                    this.loading = false
                })
            },
            // 新增编辑
            addEdit(row, method) {
                this.$refs.identificationForm.init(row, method)
            },
            // 删除
            del(id) {
                let ids = [id];
                if (!id && !this.dataListSelections.length) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                if (!id) {
                    ids = this.dataListSelections.map(item => {
                        return item.id
                    })
                }
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios(this.api.metadata.metadatafonctionsRemoveById + '/' + id, {}, 'delete').then(data => {
                        if (data.status) {
                            this.$message.success('删除成功')
                            this.refreshList()
                        } else {
                            this.$message.error('删除失败')
                        }
                    })
                })
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            reset() {
                this.$refs.searchForm.resetFields();
                this.refreshList(1)
            }
        }
    }
</script>

<style scoped>

</style>
